<template>
  <section class="about-us-banner">
    <MainBanner :heading="heading" :desc="desc" />

  </section>
</template>

<script setup>
import MainBanner from "../Global/MainBanner.vue";
const heading = "Service Area";
const desc = "We take pride in our extensive service area, which enables us to cater to a diverse range of clients. We are committed to meeting the needs of our customers effectively and efficiently, no matter where they are located. ";

</script>

<style scoped>
.about-us-banner {
  background-image: linear-gradient(to right, rgba(0, 29, 51, 0.8), rgba(90, 99, 105, 0.8)), url("../../assets//v-1.1/Banners/services-area-banner.png");
  background-size: cover;
  background-repeat: no-repeat;
  margin-top: 5.5rem;
}
</style>